import { render, staticRenderFns } from "./ModalIdle.vue?vue&type=template&id=025967ce&scoped=true&"
import script from "./ModalIdle.vue?vue&type=script&lang=js&"
export * from "./ModalIdle.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdle.vue?vue&type=style&index=0&id=025967ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025967ce",
  null
  
)

export default component.exports